import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/staticpage/";

const StaticPageApi = {
	getByDossier(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}
};

export default StaticPageApi;
